import { reducerConfirmationActions } from './confirmation.reducer';
import * as actionImport from './confirmation.actions';

export const ConfirmationActions = { ...reducerConfirmationActions, ...actionImport };
